export default {
    path: '/jobs',
    component: () => import('source/pages/root/JobPostingsPageGroup.vue'),
    meta: {
        title: 'HQZen - Job Postings',
        loginRequired: false
    },

    children: [
            {
                path: '',
                name: 'jobs',
                component: () => import('source/pages/job-postings/JobPostings.vue'),
                props: true,
                meta: {
                    title: 'HQZen Job Postings',
                    canDisplayGlobalModals: false
                },
            },
            {
                path: 'job-post/:job_posting_id/:search_filters?',
                name: 'job-post',
                component: () => import('source/pages/job-postings/JobPost.vue'),
                props: true,
                meta: {
                    title: 'HQZen Job Postings',
                    canDisplayGlobalModals: false,
                }
            }
        ]
};
